var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "NewsIcon",
    d: "M16,6h3a1,1,0,0,1,1,1V18a2,2,0,0,1-2,2m0,0a2,2,0,0,1-2-2V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V17a3,3,0,0,0,3,3ZM8,8h4M8,12h4M8,16h4",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsIconDark);
export default __webpack_public_path__ + "static/media/NewsIconDark.6f77bf28bc9a376f8fa9f618a177feb1.svg";
export { ForwardRef as ReactComponent };